import { render, staticRenderFns } from "./PolicyAccessCrmReservations.vue?vue&type=template&id=65190c48"
import script from "./PolicyAccessCrmReservations.vue?vue&type=script&lang=js"
export * from "./PolicyAccessCrmReservations.vue?vue&type=script&lang=js"
import style0 from "./PolicyAccessCrmReservations.vue?vue&type=style&index=0&id=65190c48&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports